<template>
  <el-dialog
    :visible.sync="isVisible"
    :append-to-body="true"
    :show-close="false"
    custom-class="fifl-referral-welcome-dialog"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <section class="referral-welcome-dialog__header">
      <h1>환영합니다!</h1>
      <h3>
        귀하는 <strong>{{ centerName }}</strong>의 초대를 받으셨습니다. 피플박스<br> 
        가입 후 유료 플랜으로 전환하는 즉시 플랜 1개월<br>
        무료 연장 혜택이 제공됩니다.
      </h3>
      <p>
        피플박스 파트너사로 이미 가입했다면 
        <a 
          href="#" 
          @click.prevent="goToLoginPage"
        >
          로그인
        </a>
        을 해주세요.
      </p>
    </section>
    <section class="referral-welcome-dialog__body">
      <ul>
        <li 
          v-for="content in blackPlanBenefits"
          :key="content.id"
        >
          <div :style="{'background-image': 'url('+content.src+')'}" />
          <p>{{ content.label }}</p>
        </li>
      </ul>
    </section>
    <section class="referral-welcome-dialog__bottom">
      <button @click.prevent="closeDialog">지금 바로 가입하기</button>
    </section>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogCenterName: {
      type: String,
      default: '센터네임',
    },
  },
  data(){
    return {
      blackPlanBenefits: [
        {
          id: 'cross-platform',
          label: '모든 디바이스 지원',
          src: 'image/icon/icon/referral/devices.svg',
        },
        {
          id: 'realtime-schedule',
          label: '실시간 스케줄링',
          src: 'image/icon/icon/referral/calendar.svg',
        },
        {
          id: 'manage-course',
          label: '1:1/그룹 수업 관리',
          src: 'image/icon/icon/referral/users.svg',
        },
        {
          id: 'membership-simple-register',
          label: '회원권 간편 등록',
          src: 'image/icon/icon/referral/card.svg',
        },
        {
          id: 'counting',
          label: '횟수 자동 차감',
          src: 'image/icon/icon/referral/payment-method.svg',
        },
        {
          id: 'course-history-inquiry',
          label: '수강 내역 조회',
          src: 'image/icon/icon/referral/clipboard.svg',
        },
        {
          id: 'reservation',
          label: '지정 고정 예약',
          src: 'image/icon/icon/referral/user.svg',
        },
        {
          id: 'wod',
          label: '오늘의 운동 공유',
          src: 'image/icon/icon/referral/wod.svg',
        },
        {
          id: 'push-messaging',
          label: '푸시 자동 알림',
          src: 'image/icon/icon/referral/alarm.svg',
        },
        {
          id: 'locker-managing',
          label: '락커 관리',
          src: 'image/icon/icon/referral/locker.svg',
        }
      ]
    }
  },
  computed: {
    centerName(){
      return this.dialogCenterName;
    },
    isVisible(){
      return this.dialogVisible;
    }
  },
  methods:{
    goToLoginPage(){
      this.$router.push('/');
    },
    closeDialog(){
      this.$emit('close')
    }
  }
};
</script>

<style lang='scss'>
    @function mb-calculator($px) {
        @return 100 * $px / 375
    }
    .el-dialog.fifl-referral-welcome-dialog{
        width: 900px;
        border-radius: 17px;
        @media screen and (max-width: 768px) {
             width: 100%;
             min-height: 100%;
             border-radius: 0;
             margin: 0 !important;
             position: absolute;
             top: 0;
        }
        .el-dialog__body{
            padding: 40px 0;
        }
        .referral-welcome-dialog__header{
            color: #000000;
            margin: 0 auto;
            h1{
                font-size: 25px;
                font-weight: 300;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: -1px;
                text-align: center;
                margin: 0 auto;
            }
            h3{
                font-size: 15px;
                font-weight: 300;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: -0.8px;
                text-align: center;
                margin: 15px auto;
            }
            p{
                font-size: 12px;
                font-weight: 300;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: -0.64px;
                text-align: center;
                color: #4a4a4a;
                a{
                    text-decoration: underline;
                    font-weight: 500;
                    margin: 0 auto;
                    color: #000000;
                }
            }
        }
        .referral-welcome-dialog__body{
            background-color: #f2f2f2;
            margin: 30px auto;
            ul{
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                padding: 30px 0 20px 10px;
                position: relative;
                @media screen and (max-width: 768px) {
                    padding-left: mb-calculator(10) * 1vw;
                } 
                li{ 
                    width: 145px;
                    border-radius: 14px;
                    box-shadow: 0 3px 9px 0 rgba(0, 20, 29, 0.1);
                    background-color: #ffffff;
                    padding: 20px 0 15px 0;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    @media screen and (max-width: 768px) {
                        border-radius: mb-calculator(9.1) * 1vw;
                        width: mb-calculator(95) * 1vw;
                        padding: mb-calculator(11) * 1vw 0;
                        margin-right: mb-calculator(10) * 1vw;
                        margin-bottom: mb-calculator(10) * 1vw;
                        &:last-child{
                            display: none;
                        }
                    }                          
                    div{
                        height: 45px;
                        width: 45px;
                        box-sizing: border-box;
                        margin: auto auto 5px auto;
                        background-repeat: no-repeat;
                        background-position: center center;
                        background-size: contain;
                        @media screen and (max-width: 768px) {
                            width: mb-calculator(30) * 1vw;
                            height: mb-calculator(30) * 1vw;
                            margin-bottom: mb-calculator(5) * 1vw;
                        }
                    }
                    p{
                        font-size: 14px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: -0.8px;
                        text-align: center;
                        color: #424242;
                        margin: 0 auto;
                        @media screen and (max-width: 768px) {
                            font-size: mb-calculator(9) * 1vw;
                        } 
                    }
                }
            }
        }
        .referral-welcome-dialog__bottom{
            text-align: center;
            button{
                cursor: pointer;
                outline: none;
                border: none;
                width: 350px;
                height: 50px;
                background-color: #d3d3d3;
                color: #4a4a4a;
                border-radius: 4px;
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: -0.5px;
                text-align: center;
                @media screen and (max-width: 768px) {
                    width: calc(100% - 80px)
                }
            }
        }
    }
</style>